var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-row',{staticClass:"info text-primary my-3"},[_c('b-col',{attrs:{"cols":"9","md":"9"}},[_vm._t("default")],2),_c('b-col',{staticClass:"text-right",attrs:{"cols":"3","md":"3"}},[_c('BIconBrightnessHigh')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }